<template>
    <main ref="main">
        <nuxt-page class="view main-content" />
    </main>
</template>

<script setup lang="ts">
    defineOptions({
        name: 'VzLayoutDefault',
    });
</script>

<style lang="scss">
    .view {
        overflow: auto;
    }

    .main-content {
        grid-area: main-content;
        height: 100%;
        overflow: hidden;
    }
</style>
